const RELOAD_STAMP_KEY = 'stale_chunk_reload_at';
const RELOAD_COOLDOWN_MS = 10 * 1000;

function reloadForNewDeployment() {
  try {
    const lastReload = Number(sessionStorage.getItem(RELOAD_STAMP_KEY));
    if (lastReload && Date.now() - lastReload < RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(RELOAD_STAMP_KEY, String(Date.now()));
  } catch {
    return;
  }
  window.location.reload();
}

export function reloadOnStaleChunks() {
  window.addEventListener('vite:preloadError', reloadForNewDeployment);
}
